<template>
  <a-row type="flex" :gutter="{xl: 24, xxl: 0}" class="status">
    <a-col :xxl="24" :xl="12" :xs="24" class="status-1 mb24">
      <div class="status-designer">
        <h5>
          {{ $t('dashboard.second.title') }}
          <!--<b-icon type="icongouwuche" @click.native="$router.push({path: 'robot&studio/purchase', query: {studioId: designer.id}})"></b-icon>-->
        </h5>
        <div class="status-item">
          <div class="data">
            <div class="data-base">
              <i18n path="dashboard.second.remainDays" tag="p">
                <strong place="day">{{ designer.days }}</strong>
              </i18n>
              <!--<p>
                剩余
                <strong v-text="designer.days"></strong>
                <span>天</span>
              </p>-->
            </div>
            <div class="data-icon">
              <b-icon type="iconshalou"></b-icon>
            </div>
          </div>
          <p class="other">
            {{ $t('dashboard.second.expireDate') }} {{ designer.date }}
          </p>
        </div>
      </div>
    </a-col>
    <a-col :xxl="24" :xl="12" :xs="24" class="status-2 mb24">
      <div class="status-robot">
        <h5>
          {{ $t('dashboard.third.title') }}
          <b-icon type="icongouwuche" @click.native="$router.push({path: 'robot&studio/purchase'})"></b-icon>
        </h5>
        <a-table
          class="robot-content"
          rowKey="id"
          size="small"
          :columns="columns"
          :dataSource="agent"
          :pagination="false">
          <span slot="status" slot-scope="record">
            <b-icon type="icondaoqishijian" :class="record.days > 0 ? 'normal' : 'overrun'"></b-icon>
          </span>
          <p class="ellipsis" slot="name" slot-scope="record">
            <a-tooltip placement="bottomLeft" :title="getAgentName(record)">
              {{ getAgentName(record) }}
            </a-tooltip>
          </p>
          <span slot="operation" slot-scope="record">
            <span v-if="false">{{ record }}</span>
              <b-icon type="icongouwuche" @click.native="$router.push({path: 'robot&studio/purchase', query: {agentIds: record.id}})"></b-icon>
          </span>
        </a-table>
        <p class="more">
          <span @click="$router.push('/robot&studio')">
            {{ $t('dashboard.common.details') }}
            <b-icon type="iconyou"></b-icon>
          </span>
        </p>
      </div>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'Line1right',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      agent: [],
      designer: {},
      columns: [{
        title: this.$t('dashboard.third.status'),
        key: 'status',
        width: 50,
        scopedSlots: { customRender: 'status' },
        customHeaderCell: () => {
          return {
            style: {
              minWidth: '50px'
            }
          }
        }
      }, {
        title: this.$t('dashboard.third.name'),
        key: 'agentAlias',
        customHeaderCell: () => {
          return {
            style: {
              minWidth: '100px',
              maxWidth: '120px'
            }
          }
        },
        customCell: (record, index) => {
          return {
            attrs: {
              class: 'ellipsis'
            },
            style: {
              minWidth: '100px',
              maxWidth: '100px'
            }
          }
        },
        scopedSlots: { customRender: 'name' }
      }, {
        title: this.$t('dashboard.third.expireDate'),
        dataIndex: 'expireDate',
        width: 100,
        customHeaderCell: () => {
          return {
            style: {
              minWidth: '100px'
            }
          }
        },
        customCell: (record, index) => {
          return {
            style: {
              color: record.days > 0 ? '#333' : '#F5222D'
            }
          }
        },
        customRender: (text, record, index) => {
          return text.slice(0, 10)
        }
      },
      {
        title: '',
        key: 'operation',
        width: 15,
        scopedSlots: { customRender: 'operation' }
      }
      ]
    }
  },
  watch: {
    'data' (val) {
      if (val) {
        this.designer = val.designer || {}
        this.agent = val.agent.slice(0, 3) || []
      }
    }
  },
  created () {
    // console.log(this.data, 'iiii')
  },
  methods: {
    getAgentName (record) {
      if (record.agentAlias) {
        return record.agentAlias
      } else if (record.userName || record.agentName) {
        return record.userName + '@' + record.agentName
      } else {
        return record.agentNo
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@assets/styles/base/media.less";
.status{
  .xxl-screen({
    flex-direction: column;
    height: 100%;
  });
  .status-2{
    flex: 1;
  }
  h5{
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #121212;
      padding: 0 24px;
      font-weight: normal;
      display: flex;
      justify-content: space-between;
      border-bottom: 2px solid #d9d9d9;
      .iconfont{
        color: #4977fc;
        font-size: 16px;
        cursor: pointer;
      }
    }
  .status-designer{
    background-color: #fff;
    .status-item{
      padding: 0 24px;
      background-color: #fff;
      box-shadow: 2px 2px 6px 1px rgba(239, 241, 245, 0.64);
      .data{
        padding: 56px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .data-base{
          flex: 1;
          p{
            font-size: 14px;
            color: #666;
            margin-top: 20px;
            line-height: 33px;
            strong{
              font-size: 42px;
              color: #F5222D;
              font-weight: normal;
              margin: 0 8px;
              line-height: 33px;
            }
          }
        }
        .data-icon{
          background-color: #eeeeee;
          width: 68px;
          height: 68px;
          line-height: 68px;
          text-align: center;
          border-radius: 50%;
          color: #4977fc;
          .iconfont{
            font-size: 28px;
          }
        }
      }
      .other{
        border-top: 1px solid #edeef2;
        line-height: 32px;
        color: #999;
        font-size: 14px;
      }
    }
  }
  .status-robot{
    background-color: #fff;
    height: 100%;
    position: relative;
    padding-bottom: 34px;
    overflow: hidden;
    .robot-content{
      padding: 10px 24px 10px;
      /*height: 278px;*/
      overflow: hidden;
      .icongouwuche{
        color: #4977fc;
        font-size: 14px;
        cursor: pointer;
      }
      .icondaoqishijian{
        font-size: 14px;
        &.normal{
          color: #21A61D;
        }
        &.overrun, &.except{
          color: #F5222D;
        }
      }
      /deep/ .ant-table{
        border: 0 none;
        color: #333;
        .ant-table-body{
          margin: 0;
          .ant-table-thead{
            th{
              background-color: #FAFAFA;
              color: #333333;
            }
          }
          .ant-table-tbody{
            table{
              width: 100%;
              overflow: hidden;
            }
          }
          //#FAFAFA
        }
      }
    }
    .more{
      text-align: right;
      font-size: 14px;
      color: #4977FC;
      padding: 0 24px 10px;
      position: absolute;
      bottom: 0;
      right: 0;
      span{
        cursor: pointer;
      }
    }
  }
}
</style>
